import React, { useEffect, useState } from 'react';
import API from '../api';
import { IcAlertTriangle, IcTrash, IcX, IcEye, IcRefresh } from './Icons';

const BASE = 'https://chefdeclasse.com';

export default function Unknowns() {
  const [persons, setPersons] = useState([]);
  const [selected, setSelected] = useState(null);
  const [formType, setFormType] = useState('student');
  const [form, setForm] = useState({ first_name: '', last_name: '', class_name: '', subject: '', parent_email: '', email: '' });
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const load = () => API.get('/unknown/school/1').then(r => setPersons(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    await API.delete(`/unknown/${id}`);
    load(); if (selected?.id === id) setSelected(null);
  };

  const register = async () => {
    if (!form.first_name || !form.last_name) return setMsg('Prénom et nom requis');
    setLoading(true); setMsg('');
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => v && fd.append(k, v));
    const url = formType === 'student' ? `/unknown/${selected.id}/register-as-student` : `/unknown/${selected.id}/register-as-teacher`;
    try {
      await API.post(url, fd);
      setMsg('ok');
      load();
      setTimeout(() => { setSelected(null); setMsg(''); }, 1200);
    } catch (e) { setMsg(e.response?.data?.detail || 'Erreur'); }
    setLoading(false);
  };

  const F = ({ label, k, type = 'text' }) => (
    <div>
      <label className="label">{label}</label>
      <input className="input" type={type} value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} />
    </div>
  );

  const repeat3 = persons.filter(p => p.seen_count >= 3).length;

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h1 className="page-title">Inconnus</h1>
          <p className="page-subtitle">
            {persons.length} visage{persons.length > 1 ? 's' : ''} non identifié{persons.length > 1 ? 's' : ''}
            {repeat3 > 0 && <span style={{ color: 'var(--red)', fontWeight: 600 }}> · {repeat3} récurrent{repeat3 > 1 ? 's' : ''}</span>}
          </p>
        </div>
        <button className="btn btn-ghost" onClick={load}>
          <IcRefresh size={14} strokeWidth={2} /> Actualiser
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 360px' : '1fr', gap: 20, alignItems: 'start' }}>
        {/* Grille photos */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 14 }}>
          {persons.length === 0 && (
            <div className="card empty" style={{ gridColumn: '1/-1', padding: 48 }}>
              <IcAlertTriangle size={40} stroke="var(--slate-300)" />
              <p style={{ marginTop: 14 }}>Aucun inconnu détecté</p>
            </div>
          )}
          {persons.map(p => {
            const isSelected = selected?.id === p.id;
            const isRepeat = p.seen_count >= 3;
            return (
              <div key={p.id} onClick={() => { setSelected(p); setForm({ first_name:'',last_name:'',class_name:'',subject:'',parent_email:'',email:'' }); setMsg(''); }}
                className="card" style={{
                  overflow: 'hidden', cursor: 'pointer',
                  border: isSelected ? '2px solid var(--indigo)' : '1px solid var(--slate-200)',
                  transition: 'all 0.15s',
                  boxShadow: isSelected ? '0 0 0 3px var(--indigo-l)' : 'var(--shadow)',
                }}
              >
                <div style={{ position: 'relative', aspectRatio: '1', background: 'var(--slate-100)' }}>
                  <img src={`${BASE}${p.photo_url}`} alt={p.code}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    onError={e => { e.target.style.display = 'none'; }} />
                  {isRepeat && (
                    <div style={{ position: 'absolute', top: 8, right: 8, background: 'var(--red)', color: '#fff', borderRadius: 999, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>
                      ×{p.seen_count}
                    </div>
                  )}
                </div>
                <div style={{ padding: '10px 12px' }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--slate-800)' }}>{p.code}</div>
                  <div style={{ fontSize: 11, color: isRepeat ? 'var(--red)' : 'var(--slate-400)', marginTop: 2, fontWeight: isRepeat ? 600 : 400 }}>
                    Vu {p.seen_count} fois
                  </div>
                  <div style={{ fontSize: 10, color: 'var(--slate-300)', marginTop: 2 }}>
                    {new Date(p.last_seen).toLocaleDateString('fr-FR')}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Panneau latéral */}
        {selected && (
          <div className="card" style={{ padding: 24, position: 'sticky', top: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--slate-800)' }}>{selected.code}</div>
              <button className="btn btn-ghost btn-icon btn-sm" onClick={() => setSelected(null)}><IcX size={14} /></button>
            </div>

            <img src={`${BASE}${selected.photo_url}`} alt={selected.code}
              style={{ width: '100%', borderRadius: 10, objectFit: 'cover', maxHeight: 180, marginBottom: 16, background: 'var(--slate-100)' }}
              onError={e => { e.target.style.display = 'none'; }} />

            <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
              <span className={`badge ${selected.seen_count >= 3 ? 'badge-red' : 'badge-slate'}`}>Vu {selected.seen_count} fois</span>
              <span className="badge badge-slate">{new Date(selected.first_seen).toLocaleDateString('fr-FR')}</span>
            </div>

            <hr className="divider" style={{ marginBottom: 18 }} />
            <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--slate-700)', marginBottom: 12 }}>Enregistrer comme</div>

            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              {['student','teacher'].map(t => (
                <button key={t} onClick={() => setFormType(t)} style={{
                  flex: 1, padding: '7px', border: `2px solid ${formType===t ? 'var(--indigo)' : 'var(--slate-200)'}`,
                  borderRadius: 8, background: formType===t ? 'var(--indigo-l)' : '#fff',
                  color: formType===t ? 'var(--indigo)' : 'var(--slate-500)',
                  fontWeight: 600, fontSize: 12, cursor: 'pointer',
                }}>
                  {t === 'student' ? 'Élève' : 'Enseignant'}
                </button>
              ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14 }}>
              <F label="Prénom" k="first_name" />
              <F label="Nom" k="last_name" />
              {formType === 'student' ? <>
                <F label="Classe" k="class_name" />
                <F label="Email parent" k="parent_email" type="email" />
              </> : <>
                <F label="Matière" k="subject" />
                <F label="Email" k="email" type="email" />
              </>}
            </div>

            {msg && msg !== 'ok' && <div style={{ padding: '8px 12px', background:'var(--red-l)', color:'var(--red)', borderRadius:7, fontSize:12, marginBottom:12 }}>{msg}</div>}
            {msg === 'ok' && <div style={{ padding: '8px 12px', background:'var(--emerald-l)', color:'#065F46', borderRadius:7, fontSize:12, marginBottom:12, fontWeight:600 }}>Enregistré avec succès</div>}

            <button className="btn btn-primary" style={{ width:'100%', justifyContent:'center', marginBottom:8 }} onClick={register} disabled={loading}>
              {loading ? 'Enregistrement...' : 'Enregistrer (réutilise son embedding)'}
            </button>
            <button className="btn btn-danger" style={{ width:'100%', justifyContent:'center' }} onClick={() => del(selected.id)}>
              <IcTrash size={13} strokeWidth={2} /> Supprimer
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
